import { gsap } from "gsap";

/**
 * Recruit Animation - Utilities
 * 共通ユーティリティ関数
 */

// DOM操作ヘルパー
export const $ = (selector) => document.querySelector(selector);
export const $$ = (selector) => document.querySelectorAll(selector);

// スクロール制御（統一化）
export const scrollControl = {
  lock: () => {
    Object.assign(document.body.style, { 
      overflow: 'hidden', 
      position: 'fixed', 
      width: '100%' 
    });
  },
  unlock: () => {
    Object.assign(document.body.style, { 
      overflow: '', 
      position: '', 
      width: '' 
    });
    // documentElementも念のため確認
    document.documentElement.style.overflow = '';
  }
};

// 遅延ヘルパー
export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// デバウンス関数
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// 要素の位置情報取得
export const getElementPosition = (element) => {
  const rect = element.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY,
    width: rect.width,
    height: rect.height
  };
};

// アニメーション共通設定
export const ANIMATION_CONFIG = {
  TIMINGS: {
    imageDelay: 300,
    typingStart: 800,
    typingSpeed: 100,
    rightsHighlight: 200,
    headerShow: 500,
    animeSwitch: 2000,
    anime02Delay: 400,
    scrollUnlock: 1200
  },
  SCROLL_DISTANCE: 300,
  FINAL_PADDING: 150
};

// パフォーマンス最適化のためのDOM要素キャッシュ
export class DOMCache {
  constructor() {
    this.cache = new Map();
  }

  get(selector) {
    if (!this.cache.has(selector)) {
      this.cache.set(selector, $(selector));
    }
    return this.cache.get(selector);
  }

  getAll(selector) {
    const key = `all:${selector}`;
    if (!this.cache.has(key)) {
      this.cache.set(key, $$(selector));
    }
    return this.cache.get(key);
  }

  clear() {
    this.cache.clear();
  }
}

// グローバルキャッシュインスタンス
export const domCache = new DOMCache();

// イベントリスナー管理
export class EventManager {
  constructor() {
    this.listeners = [];
  }

  add(element, event, handler, options = {}) {
    element.addEventListener(event, handler, options);
    this.listeners.push({ element, event, handler, options });
  }

  removeAll() {
    this.listeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    this.listeners = [];
  }
}